const percentFormatter = new Intl.NumberFormat("en-CA", { style: "percent" });

export function formatPercent(percent?: number) {
	return percent != null ? percentFormatter.format(percent) : "- %";
}

export function getTimeSpanHoursMinutes(seconds?: number) {
	if (seconds == null) return { hours: 0, minutes: 0 };

	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);

	return { hours, minutes };
}

export function formatNumber(
	value: number,
	options: Intl.NumberFormatOptions = {
		maximumFractionDigits: 0,
		useGrouping: true,
	},
) {
	return new Intl.NumberFormat("en-US", options).format(value);
}

const dateFormatter = new Intl.DateTimeFormat("en-CA", {});
export function formatDate(date: Date) {
	return dateFormatter.format(date);
}

const longDateFormatter = new Intl.DateTimeFormat("en-CA", {
	dateStyle: "long",
});
export function formatDateLong(date: Date) {
	return longDateFormatter.format(date);
}

const dateTimeFormatter = new Intl.DateTimeFormat("en-CA", {
	dateStyle: "medium",
	timeStyle: "medium",
});
export function formatDateTime(date: Date) {
	return dateTimeFormatter.format(date);
}

const timeFormatter = new Intl.DateTimeFormat("en-CA", {
	timeStyle: "medium",
});
export function formatTime(date: Date) {
	return timeFormatter.format(date);
}
